import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {SuppliersService} from '../../../services/suppliers.service';
import {exhaustMap, Observable} from 'rxjs';
import {MatSelectionList} from '@angular/material/list';
import {APP_GUIDS, AppGuids} from '../../../app.guids';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {CoreService, Param, ProleisObject, Types} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-import-prisma-indices',
  templateUrl: 'pm-import-prisma-objects.component.html',
  styleUrls: ['pm-import-prisma-objects.component.scss']
})
export class PmImportPrismaObjectsComponent implements OnInit {

  @ViewChild('docList') docList: MatSelectionList;
  @ViewChild('indexList') indexList: MatSelectionList;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns: string[] = ['select', 'SNR', 'SNR_DESCR', 'INDEX_AI', 'INDEX_ZI', 'DOKU_TYP', 'DOKU_REIFE', 'DOKU_FORMAT'];
  dataSource: MatTableDataSource<ProleisObject>;
  selection: SelectionModel<ProleisObject>;

  snr: string;
  selectedSnr: string;
  mode: string;
  documents$: Observable<ProleisObject[]>;

  constructor(private cs: CoreService, private supService: SuppliersService, private route: ActivatedRoute, @Inject(APP_GUIDS) private guid: AppGuids, private router: Router) {
  }

  ngOnInit() {
    this.getMode();
    if (this.mode === 'doc') {
      this.requestDocuments();
    }
  }

  getMode() {
    if (this.route.snapshot.params.snrId) {
      this.mode = 'doc';
    } else {
      this.mode = 'snr';
    }
  }

  requestDocuments() {
    const params = this.route.snapshot.params;
    if (this.mode === 'doc') {
      this.documents$ = this.supService.getPmSnr(params.constructionId, params.indexId, params.snrId).pipe(
        exhaustMap(snr => {
          return this.supService.getPrismaDocuments(snr.NAME);
        })
      );
    } else {
      this.documents$ = this.supService.getPrismaDocuments(this.snr);
    }
    this.documents$.subscribe(documents => {
      this.dataSource = new MatTableDataSource<ProleisObject>(documents);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.selection = new SelectionModel<ProleisObject>(true, []);
    });
  }

  importSnr() {
    const selected = this.selection.selected;
    const filter = selected.map(option => option.DOKU_ID).join(',');
    const params: Param[] = [{
      name: 'REQUEST_ID_FILTER_VALUES',
      type: Types.TEXT,
      value: filter
    }, {
      name: 'SNR_FILTER_VALUE',
      type: Types.TEXT,
      value: this.snr
    }];

    this.cs.executeAction(this.route.snapshot.params.indexId, '§' + this.guid.GUID_ACTION_IMPORT_PRISMA_SNRS, params).subscribe(result => {
      this.navigateToIndices();
    });
  }

  importDocuments() {
    const selected = this.selection.selected;
    const filter = selected.map(option => option.DOKU_ID).join(',');
    const params: Param[] = [{
      name: 'REQUEST_ID_FILTER_VALUES',
      type: Types.TEXT,
      value: filter
    }];

    this.cs.executeAction(this.route.snapshot.params.snrId, '§' + this.guid.GUID_ACTION_IMPORT_PRISMA_DOCUMENTS, params).subscribe(result => {
      this.navigateToIndices();
    });
  }

  navigateToIndices() {
    this.router.navigate(['/pm-constructions/' + this.route.snapshot.params.constructionId]);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

}
